import useModal from './ModalStore';

export * from './ModalStore';

export default useModal;
